module.exports = __webpack_public_path__ + "img/finance-community-award.ab6ff36f.png";